module.exports = __webpack_public_path__ + "img/08_Howto-2.63ca9d14.jpg";